import React from "react";
import "./App.css";
import SupportPage from "./components/SupportPage";

function App() {
  return (
    <div className="App">
      <SupportPage />
    </div>
  );
}

export default App;
